import React from 'react';
import LocationTemplate from './LocationTemplate';

const BunnPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Bunn"
      stateName="North Carolina"
      countyName="Franklin"
      zipCodes={["27508"]}
      latitude={35.9621}
      longitude={-78.2547}
      population={357}
      historicalFact="Incorporated in 1913, named for an early settler, Green Walker Bunn."
      nearbyTowns={[
        "Louisburg, NC",
        "Franklinton, NC",
        "Youngsville, NC",
        "Wake Forest, NC",
        "Henderson, NC",
        "Zebulon, NC",
        "Wendell, NC",
        "Oxford, NC"
      ]}
    />
  );
};

export default BunnPage;